<template>
  <div class="userManagement">
    <div class="back" @click="router.push('/personnelManage/personnel')">
      <a-button type="primary"
        ><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button
      >
    </div>

    <div style="height: 100%; overflow-y: auto; overflow-x: hidden;">
      <a-form
          ref="formRef"
          style="margin-top: 30px"
          :model="form"
          name="basic"
          :rules="rules"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 8 }"
      >
        <a-form-item v-if="form.reviewStatus !== 1" label="审核状态" name="name">
          <a-tag v-if="form.reviewStatus === 0" color="warning">待审核</a-tag>
          <a-tag v-if="form.reviewStatus === -1"  color="warning">审核未通过</a-tag>
        </a-form-item>
        <a-form-item v-if="form.reviewStatus === -1 && form.reviewMsg" label="意见" name="name">
          {{ form.reviewMsg }}
        </a-form-item>
        <!--      <a-form-item label="公司名称" name="name">-->
        <!--        {{ form.name }}-->
        <!--      </a-form-item>-->
        <a-form-item label="公司名称" name="name">
          <a-input v-if="form.status === -1" v-model:value="form.name" placeholder="请输入" />
          <a-input v-else readOnly="true" v-model:value="form.name" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="法人姓名">
          <a-input v-model:value="form.corporationName" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="统一信用代码">
          <a-input v-model:value="form.unifyCode" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="联系人姓名" name="linkName">
          <a-input v-model:value="form.linkName" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="联系人电话" name="linkPhone">
          <a-input v-model:value="form.linkPhone" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="公司地址">
          <a-input v-model:value="form.address" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="密码" name="passwd">
          <password-input
              @focus="inputPassFocus"
              v-model:value="form.passwd"
              placeholder="请输入密码"
          />
        </a-form-item>
        <a-form-item label="确认密码" name="repassword">
          <password-input
              @focus="inputRepassFocus"
              v-model:value="form.repassword"
              placeholder="请重新输入密码"
          />
        </a-form-item>
<!--        <a-form-item label="密码" name="passwd">-->
<!--          <a-input-password-->
<!--              @focus="inputPassFocus"-->
<!--              :visibility-toggle="false"-->
<!--              v-model:value="form.passwd"-->
<!--              placeholder="请输入"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item label="确认密码" name="repassword">-->
<!--          <a-input-password-->
<!--              @focus="inputRepassFocus"-->
<!--              :visibility-toggle="false"-->
<!--              v-model:value="form.repassword"-->
<!--              placeholder="请输入"-->
<!--          />-->
<!--        </a-form-item>-->
        <a-form-item label="联系邮箱">
          <a-input v-model:value="form.email" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="申请主体类型">
          <a-radio-group v-model:value="form.category">
            <a-radio
                v-for="(item, index) in typeList"
                :key="item.id"
                :value="item.dataCode + ''"
                @change="radioChange"
            >
              {{ item.dataValue }}
              <div v-if="item.dataValue === '其它科技型企业' && flag">
                <input class="old_inp" type="text" v-model="userInput" />
              </div>
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="资质附件" name="licenseAttachmentArr" tooltip="企业需上传公司营业职照，高校/研究所需上传单位证明">
          <images-uploader
              v-model:image-urls="form.licenseAttachmentArr"
              :path-name="'license'"
              :max-count="2"
              :box-width="180"
              :box-height="120"
              @upload-success="handleUploadSuccess"
              @delete="handleDelete"
          />
        </a-form-item>
        <a-form-item
            style="margin-top: 80px"
            :wrapper-col="{ span: 7, offset: 10 }"
        >
          <a-button type="primary" ghost @click="cancel">取消</a-button>
          <a-button type="primary" style="margin-left: 60px" @click="confirm"
          >确定</a-button
          >
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watch } from "vue";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
import { selectById, updateById } from "@/api/userCenter/index.js";

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

import useUserStore from "@/store/modules/user";
import imagesUploader from '@/components/imagesUploader/index.vue'
import PasswordInput from '@/components/PasswordInput';
const store = useUserStore();

const router = useRouter();

const dataType = "companyType";
const dataCode = "category";

const checkAge = async (_rule, value) => {
  if (!value) {
    return Promise.reject("请输入电话号码");
  } else {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的电话号码");
    } else {
      return Promise.resolve();
    }
  }
};
const checkCardNo = async (_rule, value) => {
  if (value) {
    const reg =
      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的身份证号码");
    } else {
      return Promise.resolve();
    }
  }
};

const checkRePsw = async (_rule, value) => {
  console.log(_rule, form.value);
  if (!value) {
    return Promise.reject("请再次输入密码");
  } else {
    if (form.value.passwd != value) {
      return Promise.reject("密码不一致，请检查");
    } else {
      return Promise.resolve();
    }
  }
};

let typeList = ref([]); // 单选框选择

watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType);
      typeList.value = val[index].children;
      console.log(typeList.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const userInput = ref("");

const formRef = ref();
const form = ref({
  name: "XXXXXXXXXXXX公司",
  linkPhone: "",
  linkName: "",
  unifyCode: "",
  corporationName: "",
  address: "",
  passwd: "",
  repassword: "",
  email: "",
  category: "int",
  reviewStatus: undefined,
  reviewMsg:  '',
  licenseAttachmentArr: []
});

const reset = () => {
  form.value = {
    name: "",
    linkPhone: "",
    linkName: "",
    unifyCode: "",
    corporationName: "",
    address: "",
    passwd: "",
    repassword: "",
    status: 0,
    email: "",
    category: "int",
    licenseAttachmentArr: []
  };
  flag.value = false;
  userInput.value = "";
};

const rules = {
  name: [{ required: true, message: "公司名称不能为空", trigger: "change" }],
  linkName: [
    { required: true, message: "联系人姓名不能为空", trigger: "change" },
  ],
  linkPhone: [
    {
      required: true,
      trigger: "blur",
      validator: checkAge,
    },
  ],

  passwd: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 6, max: 66, message: "长度在 6 个字符以上", trigger: "blur" },
  ],
  repassword: [{ required: true, trigger: "blur", validator: checkRePsw }],
};

const flag = ref(false);

const radioChange = (e) => {
  console.log(e.target.value);
  if (e.target.value === "other") {
    flag.value = true;
  } else {
    flag.value = false;
  }
};

const inputPassFocus = (e) => {
  console.log(e.target.value);
  form.value.passwd = "";
};

const inputRepassFocus = (e) => {
  console.log(e.target.value);
  form.value.repassword = "";
};

// 获取数据
const selectByIdData = () => {
  selectById(store.deptId).then((res) => {
    console.log(res);
    if (res.code === 200) {
      if (res.data) {
        form.value = res.data;
        form.value.repassword = res.data.passwd;
        if (
          res.data.category.indexOf("other_") != -1 ||
          res.data.category.indexOf("other") != -1
        ) {
          flag.value = true;
          let arr = res.data.category.split("_");
          console.log(arr);
          form.value.category = arr[0];
          userInput.value = arr[1];
        }
      }
    }
  });
};

const handleUploadSuccess = (url, urls) => {
  console.log('上传成功', url);
  console.log('当前所有图片', urls);
};

const handleDelete = (index) => {
  console.log('删除图片索引', index);
};

// 保存
const confirm = () => {
  console.log("保存");
  formRef.value
    .validate()
    .then(() => {
      console.log("values", form.value);
      const drawerValue = JSON.parse(JSON.stringify(form.value));
      if (drawerValue.category === "other" && userInput.value !== "") {
        drawerValue.category = drawerValue.category + "_" + userInput.value;
      }
      console.log(drawerValue);

      updateById(drawerValue).then((res) => {
        if (res.code === 200) {
          //   reset();
          router.push({
            path: "/personnelManage/personnel",
          });
          message.success("成功");
        }
      });
    })
    .catch((error) => {
      console.log("error", error);
    });
};
// 取消
const cancel = () => {
  console.log("取消");
  formRef.value.resetFields();
  reset();
  router.push({
    path: "/personnelManage/personnel",
  });
};

onMounted(() => {
  selectByIdData();
});
</script>
<style lang="less" scoped>
.userManagement {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;

  .back {
    position: fixed;
    top: 93px;
    right: 50px;
  }
}

.old_inp {
  /* 移除原生边框 */
  border: none;
  /* 添加新边框*/
  border-bottom: 1px solid #000;
  /* 左侧内边距 */
  // padding-left: 10px;
  /* 输入框宽度 */
  width: 100px;
  /* 移除点击输入框时浏览器提供的默认轮廓 */
  outline: none;
  position: absolute;
  bottom: 12px;
  left: 130px;
}

/deep/.ant-radio-wrapper {
  padding: 6px 0 10px 0;
}

/deep/.ant-radio-wrapper {
  width: 139px;
}
</style>
